import { observer } from 'mobx-react-lite'
import { Trans } from '@lingui/react/macro'

import { Button } from '@jotta/ui/Button'
import SvgChatCircle from '@jotta/ui/SvgChatCircle'
import { Breakpoint, useBreakpoint } from '@jotta/ui/useBreakpoint'

import type { CollectionRef } from '../../../api/useCollection'
import type { AlbumInfoStore } from '../../../store/AlbumInfoStore'
import { AlbumCommentsDrawer } from '../../Comments/AlbumCommentsDrawer'
import { useCommentsOpenState } from '../../Comments/useCommentsOpenState'
import {
  type ActionDispatcherProps,
  AlbumAction,
} from '../../PhotoActions/PhotoActions'

function AlbumActionTrigger({
  onClick,
  loading,
  label,
  icon,
}: ActionDispatcherProps) {
  const md = useBreakpoint(Breakpoint.md)
  return (
    <Button
      className="btn btn-tonal"
      onClick={onClick}
      loading={loading}
      icon={icon}
    >
      {md && label}
    </Button>
  )
}

export const AlbumActionPanel = observer<{
  collectionRef: CollectionRef
  store: AlbumInfoStore
}>(function AlbumActionPanel({ collectionRef, store }) {
  const md = useBreakpoint(Breakpoint.md)
  const [commentsDrawerOpen, setCommentsDrawerOpen] = useCommentsOpenState({
    type: 'album',
  })

  const commentsEnabled = store.showComments.enabled

  return (
    <div className="flex justify-end gap-2">
      {commentsEnabled && (
        <AlbumCommentsDrawer
          open={commentsDrawerOpen}
          onOpenChange={setCommentsDrawerOpen}
          album={store.album}
        />
      )}
      <AlbumAction.Provider
        albumIdOrShareId={store.albumIdOrShareId}
        collectionRef={collectionRef}
        actionDispatcherComponent={AlbumActionTrigger}
      >
        {commentsEnabled && (
          <Button
            className="btn btn-tonal"
            onClick={() => setCommentsDrawerOpen(true)}
            icon={SvgChatCircle}
          >
            {md && <Trans>Comments</Trans>}
          </Button>
        )}
        <AlbumAction.AddPhotos />
        <AlbumAction.ShareAlbum />
        <AlbumAction.DownloadAlbum />
        <AlbumAction.DeleteAlbum />
        <AlbumAction.FollowAlbum />
        <AlbumAction.LeaveAlbum />
      </AlbumAction.Provider>
    </div>
  )
})
